"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNumberOfDaysBeforeOpportunityIsCreated = exports.getRevenueImpactDashboardCreatedPipelineAccess = exports.getRevenueImpactDashboardAccess = exports.getDashboardAccess = exports.getAllowedDomains = exports.getForceSso = exports.getIsSecuritySettingsLoaded = exports.getIsSecuritySettingsLoading = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var getSecurityState = function getSecurityState(state) {
  return state.security;
};

var getSecurityStateStatus = function getSecurityStateStatus(state) {
  return state.security.status;
};

var getIsSecuritySettingsLoading = (0, _ramda.pipe)(getSecurityStateStatus, function (state) {
  return state === _utils.StateStatus.Pending;
});
exports.getIsSecuritySettingsLoading = getIsSecuritySettingsLoading;
var getIsSecuritySettingsLoaded = (0, _ramda.pipe)(getSecurityStateStatus, function (state) {
  return state === _utils.StateStatus.Fulfilled;
});
exports.getIsSecuritySettingsLoaded = getIsSecuritySettingsLoaded;
var getForceSso = (0, _ramda.pipe)(getSecurityState, function (state) {
  return state.forceSso;
});
exports.getForceSso = getForceSso;
var getAllowedDomains = (0, _ramda.pipe)(getSecurityState, function (state) {
  return state.allowedDomains.join(', ');
});
exports.getAllowedDomains = getAllowedDomains;
var getDashboardAccess = (0, _ramda.pipe)(getSecurityState, function (state) {
  return state.dashboardAccess;
});
exports.getDashboardAccess = getDashboardAccess;
var getRevenueImpactDashboardAccess = (0, _ramda.pipe)(getSecurityState, function (state) {
  return state.revenueImpactDashboardAccess;
});
exports.getRevenueImpactDashboardAccess = getRevenueImpactDashboardAccess;
var getRevenueImpactDashboardCreatedPipelineAccess = (0, _ramda.pipe)(getSecurityState, function (state) {
  return state.revenueImpactDashboardCreatedPipeline;
});
exports.getRevenueImpactDashboardCreatedPipelineAccess = getRevenueImpactDashboardCreatedPipelineAccess;
var getNumberOfDaysBeforeOpportunityIsCreated = (0, _ramda.pipe)(getSecurityState, function (state) {
  return state.numberOfDaysBeforeOpportunityIsCreated;
});
exports.getNumberOfDaysBeforeOpportunityIsCreated = getNumberOfDaysBeforeOpportunityIsCreated;